import { render, staticRenderFns } from "./TableTypeCustomFieldNumber.vue?vue&type=template&id=3aa7e8f6"
import script from "./TableTypeCustomFieldNumber.vue?vue&type=script&lang=js"
export * from "./TableTypeCustomFieldNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports